import { URL, handleErrors } from "./depannageActions"
import { showToast, toastApiError } from "./toastActions"
import { catchApiError, normalizeApiError } from "./apiHelpers"

// CONSOMMABLES

export const POST_INVENTAIRE_CONSOMMATION_BEGIN =
	"POST_INVENTAIRE_CONSOMMATION_BEGIN"
export const POST_INVENTAIRE_CONSOMMATION_SUCCESS =
	"POST_INVENTAIRE_CONSOMMATION_SUCCESS"
export const POST_INVENTAIRE_CONSOMMATION_ERROR =
	"POST_INVENTAIRE_CONSOMMATION_ERROR"
export const POST_INVENTAIRE_CONSOMMATION_RESET =
	"POST_INVENTAIRE_CONSOMMATION_RESET"

export const postInventaireConsommationBegin = () => ({
	type: POST_INVENTAIRE_CONSOMMATION_BEGIN,
})

export const postInventaireConsommationSuccess = (consommation) => ({
	type: POST_INVENTAIRE_CONSOMMATION_SUCCESS,
	payload: consommation,
})

export const postInventaireConsommationError = (error) => ({
	type: POST_INVENTAIRE_CONSOMMATION_ERROR,
	payload: error,
})

export const postInventaireConsommationReset = () => ({
	type: POST_INVENTAIRE_CONSOMMATION_RESET,
})

export function postInventaireConsommation(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postInventaireConsommationBegin())
		return fetch(`${URL}api/consommables`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(json),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postInventaireConsommationSuccess(json))
				dispatch(showToast("success", "Stock virtuel mis à jour"))
			})
			.catch(catchApiError(dispatch, postInventaireConsommationError))
	}
}

// TRANSFERT STOCK VIRTUEL → STOCK PHYSIQUE

export const POST_INVENTAIRE_TRANSFERT_BEGIN = "POST_INVENTAIRE_TRANSFERT_BEGIN"
export const POST_INVENTAIRE_TRANSFERT_SUCCESS =
	"POST_INVENTAIRE_TRANSFERT_SUCCESS"
export const POST_INVENTAIRE_TRANSFERT_ERROR = "POST_INVENTAIRE_TRANSFERT_ERROR"
export const POST_INVENTAIRE_TRANSFERT_RESET = "POST_INVENTAIRE_TRANSFERT_RESET"

export const postInventaireTransfertBegin = () => ({
	type: POST_INVENTAIRE_TRANSFERT_BEGIN,
})

export const postInventaireTransfertSuccess = (stockVirtuel) => ({
	type: POST_INVENTAIRE_TRANSFERT_SUCCESS,
	payload: stockVirtuel,
})

export const postInventaireTransfertError = (error) => ({
	type: POST_INVENTAIRE_TRANSFERT_ERROR,
	payload: error,
})

export const postInventaireTransfertReset = () => ({
	type: POST_INVENTAIRE_TRANSFERT_RESET,
})

export function postInventaireTransfert(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postInventaireTransfertBegin())
		return fetch(`${URL}api/inventaire/transferts`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(json),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postInventaireTransfertSuccess(json))
				dispatch(
					showToast("success", "Transfert dans le stock effectué"),
				)
			})
			.catch(catchApiError(dispatch, postInventaireTransfertError))
	}
}

export const FETCH_LIENS_VIRTUELS_BEGIN = "FETCH_LIENS_VIRTUELS_BEGIN"
export const FETCH_LIENS_VIRTUELS_SUCCESS = "FETCH_LIENS_VIRTUELS_SUCCESS"
export const FETCH_LIENS_VIRTUELS_ERROR = "FETCH_LIENS_VIRTUELS_ERROR"

export const fetchLiensVirtuelsBegin = () => ({
	type: FETCH_LIENS_VIRTUELS_BEGIN,
})

export const fetchLiensVirtuelsSuccess = (liens) => ({
	type: FETCH_LIENS_VIRTUELS_SUCCESS,
	payload: liens,
})

export const fetchLiensVirtuelsError = (error) => ({
	type: FETCH_LIENS_VIRTUELS_ERROR,
	payload: error,
})

// Liens appris numéro d'article virtuel → article physique (pré-remplissage
// du modal de transfert). Endpoint réservé chef_atelier.
export function fetchLiensVirtuels() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchLiensVirtuelsBegin())
		return fetch(`${URL}api/inventaire/transferts`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchLiensVirtuelsSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchLiensVirtuelsError))
	}
}

// CORRECTION MANUELLE DU STOCK PHYSIQUE (bouton « Corriger », chef_atelier).
// Le backend déplace du restant sur les lots existants (débit FIFO / crédit
// inverse-FIFO) et notifie le boss (stock_modifie). Le SUCCESS remplace la
// liste `stock` (la réponse a la même forme que l'onglet Stock).

export const POST_INVENTAIRE_CORRECTION_BEGIN =
	"POST_INVENTAIRE_CORRECTION_BEGIN"
export const POST_INVENTAIRE_CORRECTION_SUCCESS =
	"POST_INVENTAIRE_CORRECTION_SUCCESS"
export const POST_INVENTAIRE_CORRECTION_ERROR =
	"POST_INVENTAIRE_CORRECTION_ERROR"
export const POST_INVENTAIRE_CORRECTION_RESET =
	"POST_INVENTAIRE_CORRECTION_RESET"

export const postInventaireCorrectionBegin = () => ({
	type: POST_INVENTAIRE_CORRECTION_BEGIN,
})

export const postInventaireCorrectionSuccess = (stock) => ({
	type: POST_INVENTAIRE_CORRECTION_SUCCESS,
	payload: stock,
})

export const postInventaireCorrectionError = (error) => ({
	type: POST_INVENTAIRE_CORRECTION_ERROR,
	payload: error,
})

export const postInventaireCorrectionReset = () => ({
	type: POST_INVENTAIRE_CORRECTION_RESET,
})

export function postInventaireCorrection(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postInventaireCorrectionBegin())
		return fetch(`${URL}api/inventaire/corrections`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(json),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postInventaireCorrectionSuccess(json))
				dispatch(showToast("success", "Stock corrigé"))
			})
			.catch(
				catchApiError(dispatch, postInventaireCorrectionError, {
					silent: true,
				}),
			)
	}
}

export const FETCH_INVENTAIRE_CONSOMMABLES_BEGIN =
	"FETCH_INVENTAIRE_CONSOMMABLES_BEGIN"
export const FETCH_INVENTAIRE_CONSOMMABLES_SUCCESS =
	"FETCH_INVENTAIRE_CONSOMMABLES_SUCCESS"
export const FETCH_INVENTAIRE_CONSOMMABLES_ERROR =
	"FETCH_INVENTAIRE_CONSOMMABLES_ERROR"
export const FETCH_INVENTAIRE_CONSOMMABLES_RESET =
	"FETCH_INVENTAIRE_CONSOMMABLES_RESET"

export const fetchInventaireConsommablesBegin = () => ({
	type: FETCH_INVENTAIRE_CONSOMMABLES_BEGIN,
})

export const fetchInventaireConsommablesReset = () => ({
	type: FETCH_INVENTAIRE_CONSOMMABLES_RESET,
})

export const fetchInventaireConsommablesSuccess = (categories) => ({
	type: FETCH_INVENTAIRE_CONSOMMABLES_SUCCESS,
	payload: categories,
})

export const fetchInventaireConsommablesError = (error) => ({
	type: FETCH_INVENTAIRE_CONSOMMABLES_ERROR,
	payload: error,
})

export function fetchInventaireConsommables() {
	let url = `${URL}api/consommables`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchInventaireConsommablesBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchInventaireConsommablesSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchInventaireConsommablesError))
	}
}

// CATEGORIES

export const FETCH_INVENTAIRE_CATEGORIES_BEGIN =
	"FETCH_INVENTAIRE_CATEGORIES_BEGIN"
export const FETCH_INVENTAIRE_CATEGORIES_SUCCESS =
	"FETCH_INVENTAIRE_CATEGORIES_SUCCESS"
export const FETCH_INVENTAIRE_CATEGORIES_ERROR =
	"FETCH_INVENTAIRE_CATEGORIES_ERROR"
export const FETCH_INVENTAIRE_CATEGORIES_RESET =
	"FETCH_INVENTAIRE_CATEGORIES_RESET"

export const fetchInventaireCategoriesBegin = () => ({
	type: FETCH_INVENTAIRE_CATEGORIES_BEGIN,
})

export const fetchInventaireCategoriesReset = () => ({
	type: FETCH_INVENTAIRE_CATEGORIES_RESET,
})

export const fetchInventaireCategoriesSuccess = (categories) => ({
	type: FETCH_INVENTAIRE_CATEGORIES_SUCCESS,
	payload: { categories },
})

export const fetchInventaireCategoriesError = (error) => ({
	type: FETCH_INVENTAIRE_CATEGORIES_ERROR,
	payload: { error },
})

export function fetchInventaireCategories() {
	let url = `${URL}api/inventaire/categories`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchInventaireCategoriesBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchInventaireCategoriesSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchInventaireCategoriesError))
	}
}

// CATEGORIES TRI

export const FETCH_INVENTAIRE_CATEGORIES_TRI_BEGIN =
	"FETCH_INVENTAIRE_CATEGORIES_TRI_BEGIN"
export const FETCH_INVENTAIRE_CATEGORIES_TRI_SUCCESS =
	"FETCH_INVENTAIRE_CATEGORIES_TRI_SUCCESS"
export const FETCH_INVENTAIRE_CATEGORIES_TRI_ERROR =
	"FETCH_INVENTAIRE_CATEGORIES_TRI_ERROR"
export const FETCH_INVENTAIRE_CATEGORIES_TRI_RESET =
	"FETCH_INVENTAIRE_CATEGORIES_TRI_RESET"

export const fetchInventaireCategoriesTriBegin = () => ({
	type: FETCH_INVENTAIRE_CATEGORIES_TRI_BEGIN,
})

export const fetchInventaireCategoriesTriReset = () => ({
	type: FETCH_INVENTAIRE_CATEGORIES_TRI_RESET,
})

export const fetchInventaireCategoriesTriSuccess = (categories) => ({
	type: FETCH_INVENTAIRE_CATEGORIES_TRI_SUCCESS,
	payload: { categories },
})

export const fetchInventaireCategoriesTriError = (error) => ({
	type: FETCH_INVENTAIRE_CATEGORIES_TRI_ERROR,
	payload: { error },
})

export function fetchInventaireCategoriesTri(type) {
	let url = `${URL}api/inventaire/categories?type=${type}`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchInventaireCategoriesTriBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchInventaireCategoriesTriSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchInventaireCategoriesTriError))
	}
}

export const POST_INVENTAIRE_CATEGORIE_BEGIN = "POST_INVENTAIRE_CATEGORIE_BEGIN"
export const POST_INVENTAIRE_CATEGORIE_SUCCESS =
	"POST_INVENTAIRE_CATEGORIE_SUCCESS"
export const POST_INVENTAIRE_CATEGORIE_ERROR = "POST_INVENTAIRE_CATEGORIE_ERROR"
export const POST_INVENTAIRE_CATEGORIE_RESET = "POST_INVENTAIRE_CATEGORIE_RESET"

export const postInventaireCategorieBegin = () => ({
	type: POST_INVENTAIRE_CATEGORIE_BEGIN,
})

export const postInventaireCategorieSuccess = (categories) => ({
	type: POST_INVENTAIRE_CATEGORIE_SUCCESS,
	payload: { categories },
})

export const postInventaireCategorieError = (error) => ({
	type: POST_INVENTAIRE_CATEGORIE_ERROR,
	payload: { error },
})

export const postInventaireCategorieReset = () => ({
	type: POST_INVENTAIRE_CATEGORIE_RESET,
})

export function postInventaireCategorie(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postInventaireCategorieBegin())
		return fetch(`${URL}api/inventaire/categories`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postInventaireCategorieSuccess(json))
				dispatch(showToast("success", "Catégorie enregistrée"))
			})
			.catch(catchApiError(dispatch, postInventaireCategorieError))
	}
}

export const DELETE_INVENTAIRE_CATEGORIE_BEGIN =
	"DELETE_INVENTAIRE_CATEGORIE_BEGIN"
export const DELETE_INVENTAIRE_CATEGORIE_SUCCESS =
	"DELETE_INVENTAIRE_CATEGORIE_SUCCESS"
export const DELETE_INVENTAIRE_CATEGORIE_ERROR =
	"DELETE_INVENTAIRE_CATEGORIE_ERROR"
export const DELETE_INVENTAIRE_CATEGORIE_RESET =
	"DELETE_INVENTAIRE_CATEGORIE_RESET"

export const deleteInventaireCategorieBegin = () => ({
	type: DELETE_INVENTAIRE_CATEGORIE_BEGIN,
})

export const deleteInventaireCategorieSuccess = (categories) => ({
	type: DELETE_INVENTAIRE_CATEGORIE_SUCCESS,
	payload: { categories },
})

export const deleteInventaireCategorieError = (error) => ({
	type: DELETE_INVENTAIRE_CATEGORIE_ERROR,
	payload: { error },
})

export const deleteInventaireCategorieReset = () => ({
	type: DELETE_INVENTAIRE_CATEGORIE_RESET,
})

export function deleteInventaireCategorie(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteInventaireCategorieBegin())
		return fetch(`${URL}api/inventaire/categories`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteInventaireCategorieSuccess(json))
				dispatch(showToast("success", "Catégorie supprimée"))
			})
			.catch(catchApiError(dispatch, deleteInventaireCategorieError))
	}
}

// FOURNISSEURS

export const FETCH_INVENTAIRE_FOURNISSEURS_BEGIN =
	"FETCH_INVENTAIRE_FOURNISSEURS_BEGIN"
export const FETCH_INVENTAIRE_FOURNISSEURS_SUCCESS =
	"FETCH_INVENTAIRE_FOURNISSEURS_SUCCESS"
export const FETCH_INVENTAIRE_FOURNISSEURS_ERROR =
	"FETCH_INVENTAIRE_FOURNISSEURS_ERROR"
export const FETCH_INVENTAIRE_FOURNISSEURS_RESET =
	"FETCH_INVENTAIRE_FOURNISSEURS_RESET"

export const fetchInventaireFournisseursBegin = () => ({
	type: FETCH_INVENTAIRE_FOURNISSEURS_BEGIN,
})

export const fetchInventaireFournisseursReset = () => ({
	type: FETCH_INVENTAIRE_FOURNISSEURS_RESET,
})

export const fetchInventaireFournisseursSuccess = (fournisseurs) => ({
	type: FETCH_INVENTAIRE_FOURNISSEURS_SUCCESS,
	payload: { fournisseurs },
})

export const fetchInventaireFournisseursError = (error) => ({
	type: FETCH_INVENTAIRE_FOURNISSEURS_ERROR,
	payload: { error },
})

export function fetchInventaireFournisseurs(id = 0) {
	let url = `${URL}api/inventaire/fournisseurs`
	if (id > 0) url += `?fournisseur=${id}`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchInventaireFournisseursBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchInventaireFournisseursSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchInventaireFournisseursError))
	}
}

export const POST_INVENTAIRE_FOURNISSEUR_BEGIN =
	"POST_INVENTAIRE_FOURNISSEUR_BEGIN"
export const POST_INVENTAIRE_FOURNISSEUR_SUCCESS =
	"POST_INVENTAIRE_FOURNISSEUR_SUCCESS"
export const POST_INVENTAIRE_FOURNISSEUR_ERROR =
	"POST_INVENTAIRE_FOURNISSEUR_ERROR"
export const POST_INVENTAIRE_FOURNISSEUR_RESET =
	"POST_INVENTAIRE_FOURNISSEUR_RESET"

export const postInventaireFournisseurBegin = () => ({
	type: POST_INVENTAIRE_FOURNISSEUR_BEGIN,
})

export const postInventaireFournisseurSuccess = (fournisseurs) => ({
	type: POST_INVENTAIRE_FOURNISSEUR_SUCCESS,
	payload: { fournisseurs },
})

export const postInventaireFournisseurError = (error) => ({
	type: POST_INVENTAIRE_FOURNISSEUR_ERROR,
	payload: { error },
})

export const postInventaireFournisseurReset = () => ({
	type: POST_INVENTAIRE_FOURNISSEUR_RESET,
})

export function postInventaireFournisseur(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postInventaireFournisseurBegin())
		return fetch(`${URL}api/inventaire/fournisseurs`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postInventaireFournisseurSuccess(json))
				dispatch(showToast("success", "Fournisseur enregistré"))
			})
			.catch(catchApiError(dispatch, postInventaireFournisseurError))
	}
}

export const DELETE_INVENTAIRE_FOURNISSEUR_BEGIN =
	"DELETE_INVENTAIRE_FOURNISSEUR_BEGIN"
export const DELETE_INVENTAIRE_FOURNISSEUR_SUCCESS =
	"DELETE_INVENTAIRE_FOURNISSEUR_SUCCESS"
export const DELETE_INVENTAIRE_FOURNISSEUR_ERROR =
	"DELETE_INVENTAIRE_FOURNISSEUR_ERROR"
export const DELETE_INVENTAIRE_FOURNISSEUR_RESET =
	"DELETE_INVENTAIRE_FOURNISSEUR_RESET"

export const deleteInventaireFournisseurBegin = () => ({
	type: DELETE_INVENTAIRE_FOURNISSEUR_BEGIN,
})

export const deleteInventaireFournisseurSuccess = (fournisseurs) => ({
	type: DELETE_INVENTAIRE_FOURNISSEUR_SUCCESS,
	payload: { fournisseurs },
})

export const deleteInventaireFournisseurError = (error) => ({
	type: DELETE_INVENTAIRE_FOURNISSEUR_ERROR,
	payload: { error },
})

export const deleteInventaireFournisseurReset = () => ({
	type: DELETE_INVENTAIRE_FOURNISSEUR_RESET,
})

export function deleteInventaireFournisseur(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteInventaireFournisseurBegin())
		return fetch(`${URL}api/inventaire/fournisseurs`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteInventaireFournisseurSuccess(json))
				dispatch(showToast("success", "Fournisseur supprimé"))
			})
			.catch(catchApiError(dispatch, deleteInventaireFournisseurError))
	}
}

// COMMANDES

export const FETCH_INVENTAIRE_COMMANDES_BEGIN =
	"FETCH_INVENTAIRE_COMMANDES_BEGIN"
export const FETCH_INVENTAIRE_COMMANDES_SUCCESS =
	"FETCH_INVENTAIRE_COMMANDES_SUCCESS"
export const FETCH_INVENTAIRE_COMMANDES_ERROR =
	"FETCH_INVENTAIRE_COMMANDES_ERROR"
export const FETCH_INVENTAIRE_COMMANDES_RESET =
	"FETCH_INVENTAIRE_COMMANDES_RESET"

// `append` distingue le chargement initial (remplace) d'une page suivante
// (endless scroll, on concatène). `hasMore` indique s'il reste des pages.
export const fetchInventaireCommandesBegin = (append = false) => ({
	type: FETCH_INVENTAIRE_COMMANDES_BEGIN,
	append,
})

export const fetchInventaireCommandesReset = () => ({
	type: FETCH_INVENTAIRE_COMMANDES_RESET,
})

export const fetchInventaireCommandesSuccess = (
	commandes,
	append = false,
	hasMore = false,
	kwargs = null,
) => ({
	type: FETCH_INVENTAIRE_COMMANDES_SUCCESS,
	payload: { commandes },
	append,
	hasMore,
	kwargs,
})

export const fetchInventaireCommandesError = (error, append = false) => ({
	type: FETCH_INVENTAIRE_COMMANDES_ERROR,
	payload: { error },
	append,
})

// kwargs : { fournisseur?, article?, offset, limit }. Sans `limit`, l'appel
// reste celui d'avant (tout).
export function fetchInventaireCommandes(kwargs = {}) {
	let url = `${URL}api/inventaire/commandes`
	if (Object.keys(kwargs).length > 0) {
		url += "?"
		for (let key in kwargs) {
			url += `${key}=${kwargs[key]}&`
		}
		url = url.substring(0, url.length - 1)
	}
	const append = Number(kwargs.offset) > 0
	const limit = kwargs.limit
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchInventaireCommandesBegin(append))
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				const hasMore =
					limit != null &&
					Array.isArray(json) &&
					json.length === Number(limit)
				dispatch(
					fetchInventaireCommandesSuccess(
						json,
						append,
						hasMore,
						kwargs,
					),
				)
			})
			.catch(catchApiError(dispatch, fetchInventaireCommandesError))
	}
}

// STOCK VIRTUEL

export const FETCH_STOCK_VIRTUEL_BEGIN = "FETCH_STOCK_VIRTUEL_BEGIN"
export const FETCH_STOCK_VIRTUEL_SUCCESS = "FETCH_STOCK_VIRTUEL_SUCCESS"
export const FETCH_STOCK_VIRTUEL_ERROR = "FETCH_STOCK_VIRTUEL_ERROR"
export const FETCH_STOCK_VIRTUEL_RESET = "FETCH_STOCK_VIRTUEL_RESET"

// `append` distingue le chargement initial (remplace) d'une page suivante
// (endless scroll, on concatène). `hasMore` indique s'il reste des pages.
export const fetchStockVirtuelBegin = (append = false) => ({
	type: FETCH_STOCK_VIRTUEL_BEGIN,
	append,
})

export const fetchStockVirtuelReset = () => ({
	type: FETCH_STOCK_VIRTUEL_RESET,
})

export const fetchStockVirtuelSuccess = (
	stock,
	append = false,
	hasMore = false,
	kwargs = null,
) => ({
	type: FETCH_STOCK_VIRTUEL_SUCCESS,
	payload: stock,
	append,
	hasMore,
	kwargs,
})

export const fetchStockVirtuelError = (error, append = false) => ({
	type: FETCH_STOCK_VIRTUEL_ERROR,
	payload: error,
	append,
})

// kwargs supporte la pagination : { offset, limit, id? }. Sans `limit`, l'appel
// reste celui d'avant (tout).
export function fetchStockVirtuel(kwargs = {}) {
	let url = `${URL}api/stockvirtuel`
	if (Object.keys(kwargs).length > 0) {
		url += "?"
		for (let key in kwargs) {
			url += `${key}=${kwargs[key]}&`
		}
		url = url.substring(0, url.length - 1)
	}
	const append = Number(kwargs.offset) > 0
	const limit = kwargs.limit
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchStockVirtuelBegin(append))
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				const hasMore =
					limit != null &&
					Array.isArray(json) &&
					json.length === Number(limit)
				dispatch(
					fetchStockVirtuelSuccess(json, append, hasMore, kwargs),
				)
			})
			.catch(catchApiError(dispatch, fetchStockVirtuelError))
	}
}

// COMMANDES

export const FETCH_INVENTAIRE_VIRTUEL_COMMANDES_BEGIN =
	"FETCH_INVENTAIRE_VIRTUEL_COMMANDES_BEGIN"
export const FETCH_INVENTAIRE_VIRTUEL_COMMANDES_SUCCESS =
	"FETCH_INVENTAIRE_VIRTUEL_COMMANDES_SUCCESS"
export const FETCH_INVENTAIRE_VIRTUEL_COMMANDES_ERROR =
	"FETCH_INVENTAIRE_VIRTUEL_COMMANDES_ERROR"
// GE-55 : annulation logique d'une commande virtuelle (rupture fournisseur) /
// rétablissement. Le serveur renvoie la commande à jour → remplacée dans la
// liste de l'onglet Commandes Virtuelles. L'erreur s'affiche dans la modale
// ouverte (pas de toast) : la promesse résout {ok, message}.
export const MAJ_COMMANDE_VIRTUELLE = "MAJ_COMMANDE_VIRTUELLE"

// GE-79 : `article` (facultatif) → annule / rétablit la seule ligne.
export function postAnnulationCommandeVirtuelle({
	id,
	motif,
	retablir,
	article,
}) {
	return (dispatch, getState) => {
		const { token } = getState().navInfo.login
		const route = retablir ? "retablir" : "annulation"
		return fetch(`${URL}api/commandevirtuelle/${route}`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				id,
				...(retablir ? {} : { motif }),
				...(article ? { article } : {}),
			}),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((commande) => {
				dispatch({ type: MAJ_COMMANDE_VIRTUELLE, payload: commande })
				return { ok: true }
			})
			.catch((err) =>
				normalizeApiError(err).then((payload) => ({
					ok: false,
					message: payload.message,
				})),
			)
	}
}

export const FETCH_INVENTAIRE_VIRTUEL_COMMANDES_RESET =
	"FETCH_INVENTAIRE_VIRTUEL_COMMANDES_RESET"

// `append` distingue le chargement initial (remplace) d'une page suivante
// (endless scroll, on concatène). `hasMore` indique s'il reste des pages.
export const fetchInventaireVirtuelCommandesBegin = (append = false) => ({
	type: FETCH_INVENTAIRE_VIRTUEL_COMMANDES_BEGIN,
	append,
})

export const fetchInventaireVirtuelCommandesReset = () => ({
	type: FETCH_INVENTAIRE_VIRTUEL_COMMANDES_RESET,
})

export const fetchInventaireVirtuelCommandesSuccess = (
	commandes,
	append = false,
	hasMore = false,
	kwargs = null,
) => ({
	type: FETCH_INVENTAIRE_VIRTUEL_COMMANDES_SUCCESS,
	payload: commandes,
	append,
	hasMore,
	kwargs,
})

export const fetchInventaireVirtuelCommandesError = (
	error,
	append = false,
) => ({
	type: FETCH_INVENTAIRE_VIRTUEL_COMMANDES_ERROR,
	payload: error,
	append,
})

// kwargs supporte la pagination : { offset, limit, id? }. Sans `limit`, l'appel
// reste celui d'avant (tout, utilisé par l'ancien AtelierInventaire).
export function fetchInventaireVirtuelCommandes(kwargs = {}) {
	let url = `${URL}api/commandevirtuelle`
	if (Object.keys(kwargs).length > 0) {
		url += "?"
		for (let key in kwargs) {
			url += `${key}=${kwargs[key]}&`
		}
		url = url.substring(0, url.length - 1)
	}
	const append = Number(kwargs.offset) > 0
	const limit = kwargs.limit
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchInventaireVirtuelCommandesBegin(append))
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				// Page pleine (length === limit) → il reste probablement des
				// commandes. Sans limit (chargement complet), pas de pagination.
				const hasMore =
					limit != null &&
					Array.isArray(json) &&
					json.length === Number(limit)
				dispatch(
					fetchInventaireVirtuelCommandesSuccess(
						json,
						append,
						hasMore,
						kwargs,
					),
				)
			})
			.catch(
				catchApiError(dispatch, fetchInventaireVirtuelCommandesError),
			)
	}
}

export const POST_INVENTAIRE_COMMANDE_BEGIN = "POST_INVENTAIRE_COMMANDE_BEGIN"
export const POST_INVENTAIRE_COMMANDE_SUCCESS =
	"POST_INVENTAIRE_COMMANDE_SUCCESS"
export const POST_INVENTAIRE_COMMANDE_ERROR = "POST_INVENTAIRE_COMMANDE_ERROR"
export const POST_INVENTAIRE_COMMANDE_RESET = "POST_INVENTAIRE_COMMANDE_RESET"

export const postInventaireCommandeBegin = () => ({
	type: POST_INVENTAIRE_COMMANDE_BEGIN,
})

export const postInventaireCommandeSuccess = (commandes) => ({
	type: POST_INVENTAIRE_COMMANDE_SUCCESS,
	payload: { commandes },
})

export const postInventaireCommandeError = (error) => ({
	type: POST_INVENTAIRE_COMMANDE_ERROR,
	payload: { error },
})

export const postInventaireCommandeReset = () => ({
	type: POST_INVENTAIRE_COMMANDE_RESET,
})

export function postInventaireCommande(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postInventaireCommandeBegin())
		return fetch(`${URL}api/inventaire/commandes`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postInventaireCommandeSuccess(json))
				dispatch(showToast("success", "Commande enregistrée"))
			})
			.catch(catchApiError(dispatch, postInventaireCommandeError))
	}
}

export const UPDATE_INVENTAIRE_COMMANDE_BEGIN =
	"UPDATE_INVENTAIRE_COMMANDE_BEGIN"
export const UPDATE_INVENTAIRE_COMMANDE_SUCCESS =
	"UPDATE_INVENTAIRE_COMMANDE_SUCCESS"
export const UPDATE_INVENTAIRE_COMMANDE_ERROR =
	"UPDATE_INVENTAIRE_COMMANDE_ERROR"
export const UPDATE_INVENTAIRE_COMMANDE_RESET =
	"UPDATE_INVENTAIRE_COMMANDE_RESET"

export const updateInventaireCommandeBegin = () => ({
	type: UPDATE_INVENTAIRE_COMMANDE_BEGIN,
})

export const updateInventaireCommandeSuccess = (commandes) => ({
	type: UPDATE_INVENTAIRE_COMMANDE_SUCCESS,
	payload: { commandes },
})

export const updateInventaireCommandeError = (error) => ({
	type: UPDATE_INVENTAIRE_COMMANDE_ERROR,
	payload: { error },
})

export const updateInventaireCommandeReset = () => ({
	type: UPDATE_INVENTAIRE_COMMANDE_RESET,
})

export function updateInventaireCommande(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(updateInventaireCommandeBegin())
		return fetch(`${URL}api/inventaire/commandes`, {
			method: "put",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(updateInventaireCommandeSuccess(json))
			})
			.then(() => dispatch(fetchInventaireLimitChecker()))
			.catch(catchApiError(dispatch, updateInventaireCommandeError))
	}
}

export const DELETE_INVENTAIRE_COMMANDE_BEGIN =
	"DELETE_INVENTAIRE_COMMANDE_BEGIN"
export const DELETE_INVENTAIRE_COMMANDE_SUCCESS =
	"DELETE_INVENTAIRE_COMMANDE_SUCCESS"
export const DELETE_INVENTAIRE_COMMANDE_ERROR =
	"DELETE_INVENTAIRE_COMMANDE_ERROR"
export const DELETE_INVENTAIRE_COMMANDE_RESET =
	"DELETE_INVENTAIRE_COMMANDE_RESET"

export const deleteInventaireCommandeBegin = () => ({
	type: DELETE_INVENTAIRE_COMMANDE_BEGIN,
})

export const deleteInventaireCommandeSuccess = (commandes) => ({
	type: DELETE_INVENTAIRE_COMMANDE_SUCCESS,
	payload: { commandes },
})

export const deleteInventaireCommandeError = (error) => ({
	type: DELETE_INVENTAIRE_COMMANDE_ERROR,
	payload: { error },
})

export const deleteInventaireCommandeReset = () => ({
	type: DELETE_INVENTAIRE_COMMANDE_RESET,
})

export function deleteInventaireCommande(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteInventaireCommandeBegin())
		return fetch(`${URL}api/inventaire/commandes`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteInventaireCommandeSuccess(json))
			})
			.catch(catchApiError(dispatch, deleteInventaireCommandeError))
	}
}

// ARTICLES

export const FETCH_INVENTAIRE_ARTICLES_BEGIN = "FETCH_INVENTAIRE_ARTICLES_BEGIN"
export const FETCH_INVENTAIRE_ARTICLES_SUCCESS =
	"FETCH_INVENTAIRE_ARTICLES_SUCCESS"
export const FETCH_INVENTAIRE_ARTICLES_ERROR = "FETCH_INVENTAIRE_ARTICLES_ERROR"
export const FETCH_INVENTAIRE_ARTICLES_RESET = "FETCH_INVENTAIRE_ARTICLES_RESET"

export const fetchInventaireArticlesBegin = () => ({
	type: FETCH_INVENTAIRE_ARTICLES_BEGIN,
})

export const fetchInventaireArticlesReset = () => ({
	type: FETCH_INVENTAIRE_ARTICLES_RESET,
})

export const fetchInventaireArticlesSuccess = (articles) => ({
	type: FETCH_INVENTAIRE_ARTICLES_SUCCESS,
	payload: { articles },
})

export const fetchInventaireArticlesError = (error) => ({
	type: FETCH_INVENTAIRE_ARTICLES_ERROR,
	payload: { error },
})

export function fetchInventaireArticles(id) {
	let url = `${URL}api/inventaire/articles?categorie=${id}`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchInventaireArticlesBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchInventaireArticlesSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchInventaireArticlesError))
	}
}

export const POST_INVENTAIRE_ARTICLE_BEGIN = "POST_INVENTAIRE_ARTICLE_BEGIN"
export const POST_INVENTAIRE_ARTICLE_SUCCESS = "POST_INVENTAIRE_ARTICLE_SUCCESS"
export const POST_INVENTAIRE_ARTICLE_ERROR = "POST_INVENTAIRE_ARTICLE_ERROR"
export const POST_INVENTAIRE_ARTICLE_RESET = "POST_INVENTAIRE_ARTICLE_RESET"

export const postInventaireArticleBegin = () => ({
	type: POST_INVENTAIRE_ARTICLE_BEGIN,
})

export const postInventaireArticleSuccess = (articles) => ({
	type: POST_INVENTAIRE_ARTICLE_SUCCESS,
	payload: { articles },
})

export const postInventaireArticleError = (error) => ({
	type: POST_INVENTAIRE_ARTICLE_ERROR,
	payload: { error },
})

export const postInventaireArticleReset = () => ({
	type: POST_INVENTAIRE_ARTICLE_RESET,
})

export function postInventaireArticle(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postInventaireArticleBegin())
		return fetch(`${URL}api/inventaire/articles`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postInventaireArticleSuccess(json))
				dispatch(showToast("success", "Article enregistré"))
			})
			.then(() => dispatch(fetchInventaireLimitChecker()))
			.catch(catchApiError(dispatch, postInventaireArticleError))
	}
}

export const DELETE_INVENTAIRE_ARTICLE_BEGIN = "DELETE_INVENTAIRE_ARTICLE_BEGIN"
export const DELETE_INVENTAIRE_ARTICLE_SUCCESS =
	"DELETE_INVENTAIRE_ARTICLE_SUCCESS"
export const DELETE_INVENTAIRE_ARTICLE_ERROR = "DELETE_INVENTAIRE_ARTICLE_ERROR"
export const DELETE_INVENTAIRE_ARTICLE_RESET = "DELETE_INVENTAIRE_ARTICLE_RESET"

export const deleteInventaireArticleBegin = () => ({
	type: DELETE_INVENTAIRE_ARTICLE_BEGIN,
})

export const deleteInventaireArticleSuccess = (articles) => ({
	type: DELETE_INVENTAIRE_ARTICLE_SUCCESS,
	payload: { articles },
})

export const deleteInventaireArticleError = (error) => ({
	type: DELETE_INVENTAIRE_ARTICLE_ERROR,
	payload: { error },
})

export const deleteInventaireArticleReset = () => ({
	type: DELETE_INVENTAIRE_ARTICLE_RESET,
})

export function deleteInventaireArticle(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteInventaireArticleBegin())
		return fetch(`${URL}api/inventaire/articles`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteInventaireArticleSuccess(json))
				dispatch(showToast("success", "Article supprimé"))
			})
			.catch(catchApiError(dispatch, deleteInventaireArticleError))
	}
}

// ALLARTICLES

export const FETCH_INVENTAIRE_ALLARTICLES_BEGIN =
	"FETCH_INVENTAIRE_ALLARTICLES_BEGIN"
export const FETCH_INVENTAIRE_ALLARTICLES_SUCCESS =
	"FETCH_INVENTAIRE_ALLARTICLES_SUCCESS"
export const FETCH_INVENTAIRE_ALLARTICLES_ERROR =
	"FETCH_INVENTAIRE_ALLARTICLES_ERROR"
export const FETCH_INVENTAIRE_ALLARTICLES_RESET =
	"FETCH_INVENTAIRE_ALLARTICLES_RESET"

export const fetchInventaireAllArticlesBegin = () => ({
	type: FETCH_INVENTAIRE_ALLARTICLES_BEGIN,
})

export const fetchInventaireAllArticlesReset = () => ({
	type: FETCH_INVENTAIRE_ALLARTICLES_RESET,
})

export const fetchInventaireAllArticlesSuccess = (allArticles) => ({
	type: FETCH_INVENTAIRE_ALLARTICLES_SUCCESS,
	payload: { allArticles },
})

export const fetchInventaireAllArticlesError = (error) => ({
	type: FETCH_INVENTAIRE_ALLARTICLES_ERROR,
	payload: { error },
})

export function fetchInventaireAllArticles() {
	let url = `${URL}api/inventaire/articles`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchInventaireAllArticlesBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchInventaireAllArticlesSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchInventaireAllArticlesError))
	}
}

// STOCK VIRTUEL

export const FETCH_INVENTAIRE_STOCK_VIRTUEL_BEGIN =
	"FETCH_INVENTAIRE_STOCK_VIRTUEL_BEGIN"
export const FETCH_INVENTAIRE_STOCK_VIRTUEL_SUCCESS =
	"FETCH_INVENTAIRE_STOCK_VIRTUEL_SUCCESS"
export const FETCH_INVENTAIRE_STOCK_VIRTUEL_ERROR =
	"FETCH_INVENTAIRE_STOCK_VIRTUEL_ERROR"
export const FETCH_INVENTAIRE_STOCK_VIRTUEL_RESET =
	"FETCH_INVENTAIRE_STOCK_VIRTUEL_RESET"

export const fetchInventaireStockVirtuelBegin = () => ({
	type: FETCH_INVENTAIRE_STOCK_VIRTUEL_BEGIN,
})

export const fetchInventaireStockVirtuelReset = () => ({
	type: FETCH_INVENTAIRE_STOCK_VIRTUEL_RESET,
})

export const fetchInventaireStockVirtuelSuccess = (payload) => ({
	type: FETCH_INVENTAIRE_STOCK_VIRTUEL_SUCCESS,
	payload,
})

export const fetchInventaireStockVirtuelError = (error) => ({
	type: FETCH_INVENTAIRE_STOCK_VIRTUEL_ERROR,
	error,
})

export function fetchInventaireStockVirtuel() {
	let url = `${URL}api/inventaire/stockvirtuel`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchInventaireStockVirtuelBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchInventaireStockVirtuelSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchInventaireStockVirtuelError))
	}
}

// STOCK

export const FETCH_INVENTAIRE_STOCK_BEGIN = "FETCH_INVENTAIRE_STOCK_BEGIN"
export const FETCH_INVENTAIRE_STOCK_SUCCESS = "FETCH_INVENTAIRE_STOCK_SUCCESS"
export const FETCH_INVENTAIRE_STOCK_ERROR = "FETCH_INVENTAIRE_STOCK_ERROR"
export const FETCH_INVENTAIRE_STOCK_RESET = "FETCH_INVENTAIRE_STOCK_RESET"

export const fetchInventaireStockBegin = () => ({
	type: FETCH_INVENTAIRE_STOCK_BEGIN,
})

export const fetchInventaireStockReset = () => ({
	type: FETCH_INVENTAIRE_STOCK_RESET,
})

export const fetchInventaireStockSuccess = (stock) => ({
	type: FETCH_INVENTAIRE_STOCK_SUCCESS,
	payload: { stock },
})

export const fetchInventaireStockError = (error) => ({
	type: FETCH_INVENTAIRE_STOCK_ERROR,
	payload: { error },
})

export function fetchInventaireStock(id = 0) {
	let url = `${URL}api/inventaire/stock`
	if (id > 0) url += `?categorie=${id}`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchInventaireStockBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchInventaireStockSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchInventaireStockError))
	}
}

// ---------------------------------------------------------------------------
// STOCK / STOCK VIRTUEL — version PAGINÉE dédiée au modal AtelierInventaireModalV2
//
// Actions + champs reducer DISTINCTS de fetchInventaireStock/stock et
// fetchInventaireStockVirtuel/stockVirtuel (eux partagés par la page inventaire,
// le modal legacy et l'éditeur de modèles). On ne touche donc PAS à leur
// comportement : tout est neuf et n'est consommé que par le modal V2.
//
// `append` distingue le 1er chargement (remplace) d'une page suivante (endless
// scroll, concatène) ; `hasMore` = true tant qu'une page pleine revient.
// ---------------------------------------------------------------------------

const buildUrl = (base, kwargs) => {
	const params = Object.keys(kwargs).filter(
		(k) =>
			kwargs[k] !== undefined && kwargs[k] !== null && kwargs[k] !== "",
	)
	if (!params.length) return base
	return (
		base +
		"?" +
		params.map((k) => `${k}=${encodeURIComponent(kwargs[k])}`).join("&")
	)
}

// --- Stock physique paginé ---

export const FETCH_MODAL_STOCK_BEGIN = "FETCH_MODAL_STOCK_BEGIN"
export const FETCH_MODAL_STOCK_SUCCESS = "FETCH_MODAL_STOCK_SUCCESS"
export const FETCH_MODAL_STOCK_ERROR = "FETCH_MODAL_STOCK_ERROR"
export const FETCH_MODAL_STOCK_RESET = "FETCH_MODAL_STOCK_RESET"

export const fetchModalStockBegin = (append = false) => ({
	type: FETCH_MODAL_STOCK_BEGIN,
	append,
})
export const fetchModalStockReset = () => ({ type: FETCH_MODAL_STOCK_RESET })
export const fetchModalStockSuccess = (
	payload,
	append = false,
	hasMore = false,
) => ({ type: FETCH_MODAL_STOCK_SUCCESS, payload, append, hasMore })
export const fetchModalStockError = (error, append = false) => ({
	type: FETCH_MODAL_STOCK_ERROR,
	error,
	append,
})

// kwargs : { offset, limit, categorie?, search? }
export function fetchModalStock(kwargs = {}) {
	const url = buildUrl(`${URL}api/inventaire/stock`, kwargs)
	const append = Number(kwargs.offset) > 0
	const limit = kwargs.limit
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchModalStockBegin(append))
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				const hasMore =
					limit != null &&
					Array.isArray(json) &&
					json.length === Number(limit)
				dispatch(fetchModalStockSuccess(json, append, hasMore))
			})
			.catch(catchApiError(dispatch, fetchModalStockError))
	}
}

// --- Stock virtuel paginé ---

export const FETCH_MODAL_STOCK_VIRTUEL_BEGIN = "FETCH_MODAL_STOCK_VIRTUEL_BEGIN"
export const FETCH_MODAL_STOCK_VIRTUEL_SUCCESS =
	"FETCH_MODAL_STOCK_VIRTUEL_SUCCESS"
export const FETCH_MODAL_STOCK_VIRTUEL_ERROR = "FETCH_MODAL_STOCK_VIRTUEL_ERROR"
export const FETCH_MODAL_STOCK_VIRTUEL_RESET = "FETCH_MODAL_STOCK_VIRTUEL_RESET"

export const fetchModalStockVirtuelBegin = (append = false) => ({
	type: FETCH_MODAL_STOCK_VIRTUEL_BEGIN,
	append,
})
export const fetchModalStockVirtuelReset = () => ({
	type: FETCH_MODAL_STOCK_VIRTUEL_RESET,
})
export const fetchModalStockVirtuelSuccess = (
	payload,
	append = false,
	hasMore = false,
) => ({ type: FETCH_MODAL_STOCK_VIRTUEL_SUCCESS, payload, append, hasMore })
export const fetchModalStockVirtuelError = (error, append = false) => ({
	type: FETCH_MODAL_STOCK_VIRTUEL_ERROR,
	error,
	append,
})

// kwargs : { offset, limit }
export function fetchModalStockVirtuel(kwargs = {}) {
	const url = buildUrl(`${URL}api/inventaire/stockvirtuel`, kwargs)
	const append = Number(kwargs.offset) > 0
	const limit = kwargs.limit
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchModalStockVirtuelBegin(append))
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				const hasMore =
					limit != null &&
					Array.isArray(json) &&
					json.length === Number(limit)
				dispatch(fetchModalStockVirtuelSuccess(json, append, hasMore))
			})
			.catch(catchApiError(dispatch, fetchModalStockVirtuelError))
	}
}

// --- Commande suggérée (par plaques → référence), requête ciblée ---

export const FETCH_MODAL_SUGGESTION_BEGIN = "FETCH_MODAL_SUGGESTION_BEGIN"
export const FETCH_MODAL_SUGGESTION_SUCCESS = "FETCH_MODAL_SUGGESTION_SUCCESS"
export const FETCH_MODAL_SUGGESTION_ERROR = "FETCH_MODAL_SUGGESTION_ERROR"
export const FETCH_MODAL_SUGGESTION_RESET = "FETCH_MODAL_SUGGESTION_RESET"

export const fetchModalSuggestionBegin = () => ({
	type: FETCH_MODAL_SUGGESTION_BEGIN,
})
export const fetchModalSuggestionReset = () => ({
	type: FETCH_MODAL_SUGGESTION_RESET,
})
export const fetchModalSuggestionSuccess = (payload) => ({
	type: FETCH_MODAL_SUGGESTION_SUCCESS,
	payload,
})
export const fetchModalSuggestionError = (error) => ({
	type: FETCH_MODAL_SUGGESTION_ERROR,
	error,
})

export function fetchModalStockVirtuelSuggestion(reference) {
	const url = buildUrl(`${URL}api/inventaire/stockvirtuel`, {
		reference,
		limit: 5,
	})
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchModalSuggestionBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchModalSuggestionSuccess(json)))
			.catch(() => dispatch(fetchModalSuggestionError(true)))
	}
}

// STOCK

export const FETCH_INVENTAIRE_STOCK_TRI_BEGIN =
	"FETCH_INVENTAIRE_STOCK_TRI_BEGIN"
export const FETCH_INVENTAIRE_STOCK_TRI_SUCCESS =
	"FETCH_INVENTAIRE_STOCK_TRI_SUCCESS"
export const FETCH_INVENTAIRE_STOCK_TRI_ERROR =
	"FETCH_INVENTAIRE_STOCK_TRI_ERROR"
export const FETCH_INVENTAIRE_STOCK_TRI_RESET =
	"FETCH_INVENTAIRE_STOCK_TRI_RESET"

export const fetchInventaireStockTriBegin = () => ({
	type: FETCH_INVENTAIRE_STOCK_TRI_BEGIN,
})

export const fetchInventaireStockTriReset = () => ({
	type: FETCH_INVENTAIRE_STOCK_TRI_RESET,
})

export const fetchInventaireStockTriSuccess = (stock) => ({
	type: FETCH_INVENTAIRE_STOCK_TRI_SUCCESS,
	payload: { stock },
})

export const fetchInventaireStockTriError = (error) => ({
	type: FETCH_INVENTAIRE_STOCK_TRI_ERROR,
	payload: { error },
})

export function fetchInventaireStockTri(type) {
	let url = `${URL}api/inventaire/stock?type=${type}`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchInventaireStockTriBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchInventaireStockTriSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchInventaireStockTriError))
	}
}

// ARTICLEUSAGE

export const FETCH_INVENTAIRE_ARTICLEUSAGES_BEGIN =
	"FETCH_INVENTAIRE_ARTICLEUSAGES_BEGIN"
export const FETCH_INVENTAIRE_ARTICLEUSAGES_SUCCESS =
	"FETCH_INVENTAIRE_ARTICLEUSAGES_SUCCESS"
export const FETCH_INVENTAIRE_ARTICLEUSAGES_ERROR =
	"FETCH_INVENTAIRE_ARTICLEUSAGES_ERROR"
export const FETCH_INVENTAIRE_ARTICLEUSAGES_RESET =
	"FETCH_INVENTAIRE_ARTICLEUSAGES_RESET"

// `append` distingue le chargement initial (remplace) d'une page suivante
// (endless scroll, on concatène). `hasMore` indique s'il reste des pages.
export const fetchInventaireArticleUsagesBegin = (append = false) => ({
	type: FETCH_INVENTAIRE_ARTICLEUSAGES_BEGIN,
	append,
})

export const fetchInventaireArticleUsagesReset = () => ({
	type: FETCH_INVENTAIRE_ARTICLEUSAGES_RESET,
})

export const fetchInventaireArticleUsagesSuccess = (
	articleUsages,
	append = false,
	hasMore = false,
	kwargs = null,
) => ({
	type: FETCH_INVENTAIRE_ARTICLEUSAGES_SUCCESS,
	payload: { articleUsages },
	append,
	hasMore,
	kwargs,
})

export const fetchInventaireArticleUsagesError = (error, append = false) => ({
	type: FETCH_INVENTAIRE_ARTICLEUSAGES_ERROR,
	payload: { error },
	append,
})

// kwargs : { categorie?, article?, type?, offset, limit }. Sans `limit`, l'appel
// reste celui d'avant (tout).
export function fetchInventaireArticleUsages(kwargs = {}) {
	let url = `${URL}api/inventaire/articleusages`
	if (Object.keys(kwargs).length > 0) {
		url += "?"
		for (let key in kwargs) url += `${key}=${kwargs[key]}&`
		url = url.substring(0, url.length - 1)
	}
	const append = Number(kwargs.offset) > 0
	const limit = kwargs.limit
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchInventaireArticleUsagesBegin(append))
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				const hasMore =
					limit != null &&
					Array.isArray(json) &&
					json.length === Number(limit)
				dispatch(
					fetchInventaireArticleUsagesSuccess(
						json,
						append,
						hasMore,
						kwargs,
					),
				)
			})
			.catch(catchApiError(dispatch, fetchInventaireArticleUsagesError))
	}
}

export const POST_INVENTAIRE_ARTICLEUSAGE_BEGIN =
	"POST_INVENTAIRE_ARTICLEUSAGE_BEGIN"
export const POST_INVENTAIRE_ARTICLEUSAGE_SUCCESS =
	"POST_INVENTAIRE_ARTICLEUSAGE_SUCCESS"
export const POST_INVENTAIRE_ARTICLEUSAGE_ERROR =
	"POST_INVENTAIRE_ARTICLEUSAGE_ERROR"
export const POST_INVENTAIRE_ARTICLEUSAGE_RESET =
	"POST_INVENTAIRE_ARTICLEUSAGE_RESET"

export const postInventaireArticleUsageBegin = () => ({
	type: POST_INVENTAIRE_ARTICLEUSAGE_BEGIN,
})

export const postInventaireArticleUsageSuccess = () => ({
	type: POST_INVENTAIRE_ARTICLEUSAGE_SUCCESS,
	// payload: { articleUsage }
})

export const postInventaireArticleUsageError = (error) => ({
	type: POST_INVENTAIRE_ARTICLEUSAGE_ERROR,
	payload: { error },
})

export const postInventaireArticleUsageReset = () => ({
	type: POST_INVENTAIRE_ARTICLEUSAGE_RESET,
})

export function postInventaireArticleUsage(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postInventaireArticleUsageBegin())
		return fetch(`${URL}api/inventaire/articleusages`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postInventaireArticleUsageSuccess(json))
			})
			.catch(catchApiError(dispatch, postInventaireArticleUsageError))
	}
}

// LIMITCHECKER

export const FETCH_INVENTAIRE_LIMITCHECKER_BEGIN =
	"FETCH_INVENTAIRE_LIMITCHECKER_BEGIN"
export const FETCH_INVENTAIRE_LIMITCHECKER_SUCCESS =
	"FETCH_INVENTAIRE_LIMITCHECKER_SUCCESS"
export const FETCH_INVENTAIRE_LIMITCHECKER_ERROR =
	"FETCH_INVENTAIRE_LIMITCHECKER_ERROR"

export const fetchInventaireLimitCheckerBegin = () => ({
	type: FETCH_INVENTAIRE_LIMITCHECKER_BEGIN,
})

export const fetchInventaireLimitCheckerSuccess = (limitChecker) => ({
	type: FETCH_INVENTAIRE_LIMITCHECKER_SUCCESS,
	payload: { limitChecker },
})

export const fetchInventaireLimitCheckerError = (error) => ({
	type: FETCH_INVENTAIRE_LIMITCHECKER_ERROR,
	payload: { error },
})

export function fetchInventaireLimitChecker() {
	let url = `${URL}api/inventaire/limitchecker`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchInventaireLimitCheckerBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchInventaireLimitCheckerSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchInventaireLimitCheckerError))
	}
}

// ─── CONSOMMABLES : CRUD des catégories (Options → Stock virtuel) ───
// POST/DELETE renvoient la liste fraîche → on met `consommables` à jour via
// fetchInventaireConsommablesSuccess, plus un état dédié pour le modal.

export const POST_INVENTAIRE_CONSOMMABLE_BEGIN =
	"POST_INVENTAIRE_CONSOMMABLE_BEGIN"
export const POST_INVENTAIRE_CONSOMMABLE_SUCCESS =
	"POST_INVENTAIRE_CONSOMMABLE_SUCCESS"
export const POST_INVENTAIRE_CONSOMMABLE_ERROR =
	"POST_INVENTAIRE_CONSOMMABLE_ERROR"
export const POST_INVENTAIRE_CONSOMMABLE_RESET =
	"POST_INVENTAIRE_CONSOMMABLE_RESET"

export const postInventaireConsommableReset = () => ({
	type: POST_INVENTAIRE_CONSOMMABLE_RESET,
})

export function postInventaireConsommable(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: POST_INVENTAIRE_CONSOMMABLE_BEGIN })
		return fetch(`${URL}api/inventaire/consommables`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch({ type: POST_INVENTAIRE_CONSOMMABLE_SUCCESS })
				dispatch(fetchInventaireConsommablesSuccess(json))
				dispatch(showToast("success", "Consommable enregistré"))
			})
			.catch(
				catchApiError(dispatch, (payload) => ({
					type: POST_INVENTAIRE_CONSOMMABLE_ERROR,
					payload,
				})),
			)
	}
}

export const DELETE_INVENTAIRE_CONSOMMABLE_BEGIN =
	"DELETE_INVENTAIRE_CONSOMMABLE_BEGIN"
export const DELETE_INVENTAIRE_CONSOMMABLE_SUCCESS =
	"DELETE_INVENTAIRE_CONSOMMABLE_SUCCESS"
export const DELETE_INVENTAIRE_CONSOMMABLE_ERROR =
	"DELETE_INVENTAIRE_CONSOMMABLE_ERROR"
export const DELETE_INVENTAIRE_CONSOMMABLE_RESET =
	"DELETE_INVENTAIRE_CONSOMMABLE_RESET"

export const deleteInventaireConsommableReset = () => ({
	type: DELETE_INVENTAIRE_CONSOMMABLE_RESET,
})

export function deleteInventaireConsommable(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: DELETE_INVENTAIRE_CONSOMMABLE_BEGIN })
		return fetch(`${URL}api/inventaire/consommables`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch({ type: DELETE_INVENTAIRE_CONSOMMABLE_SUCCESS })
				dispatch(fetchInventaireConsommablesSuccess(json))
				dispatch(showToast("success", "Consommable supprimé"))
			})
			.catch(
				catchApiError(dispatch, (payload) => ({
					type: DELETE_INVENTAIRE_CONSOMMABLE_ERROR,
					payload,
				})),
			)
	}
}

// ─── CONSOMMATIONS : liste / édition / suppression (Options → Stock virtuel) ───

export const FETCH_INVENTAIRE_CONSOMMATIONS_BEGIN =
	"FETCH_INVENTAIRE_CONSOMMATIONS_BEGIN"
export const FETCH_INVENTAIRE_CONSOMMATIONS_SUCCESS =
	"FETCH_INVENTAIRE_CONSOMMATIONS_SUCCESS"
export const FETCH_INVENTAIRE_CONSOMMATIONS_ERROR =
	"FETCH_INVENTAIRE_CONSOMMATIONS_ERROR"

export function fetchInventaireConsommations(consommableId) {
	const url = `${URL}api/inventaire/consommations?consommable=${consommableId}`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: FETCH_INVENTAIRE_CONSOMMATIONS_BEGIN })
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch({
					type: FETCH_INVENTAIRE_CONSOMMATIONS_SUCCESS,
					payload: json,
				})
			})
			.catch(() => {
				dispatch({ type: FETCH_INVENTAIRE_CONSOMMATIONS_ERROR })
			})
	}
}

export const PUT_INVENTAIRE_CONSOMMATION_BEGIN =
	"PUT_INVENTAIRE_CONSOMMATION_BEGIN"
export const PUT_INVENTAIRE_CONSOMMATION_SUCCESS =
	"PUT_INVENTAIRE_CONSOMMATION_SUCCESS"
export const PUT_INVENTAIRE_CONSOMMATION_ERROR =
	"PUT_INVENTAIRE_CONSOMMATION_ERROR"
export const PUT_INVENTAIRE_CONSOMMATION_RESET =
	"PUT_INVENTAIRE_CONSOMMATION_RESET"

export const putInventaireConsommationReset = () => ({
	type: PUT_INVENTAIRE_CONSOMMATION_RESET,
})

export function putInventaireConsommation(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: PUT_INVENTAIRE_CONSOMMATION_BEGIN })
		return fetch(`${URL}api/inventaire/consommations`, {
			method: "put",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch({
					type: PUT_INVENTAIRE_CONSOMMATION_SUCCESS,
					payload: json,
				})
				dispatch(showToast("success", "Consommation modifiée"))
			})
			.catch(
				catchApiError(dispatch, (payload) => ({
					type: PUT_INVENTAIRE_CONSOMMATION_ERROR,
					payload,
				})),
			)
	}
}

export const DELETE_INVENTAIRE_CONSOMMATION_BEGIN =
	"DELETE_INVENTAIRE_CONSOMMATION_BEGIN"
export const DELETE_INVENTAIRE_CONSOMMATION_SUCCESS =
	"DELETE_INVENTAIRE_CONSOMMATION_SUCCESS"
export const DELETE_INVENTAIRE_CONSOMMATION_ERROR =
	"DELETE_INVENTAIRE_CONSOMMATION_ERROR"
export const DELETE_INVENTAIRE_CONSOMMATION_RESET =
	"DELETE_INVENTAIRE_CONSOMMATION_RESET"

export const deleteInventaireConsommationReset = () => ({
	type: DELETE_INVENTAIRE_CONSOMMATION_RESET,
})

export function deleteInventaireConsommation(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch({ type: DELETE_INVENTAIRE_CONSOMMATION_BEGIN })
		return fetch(`${URL}api/inventaire/consommations`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch({
					type: DELETE_INVENTAIRE_CONSOMMATION_SUCCESS,
					payload: json,
				})
				dispatch(showToast("success", "Consommation supprimée"))
			})
			.catch(
				catchApiError(dispatch, (payload) => ({
					type: DELETE_INVENTAIRE_CONSOMMATION_ERROR,
					payload,
				})),
			)
	}
}

// STOCK NON DÉBITÉ (compteur nav)

export const FETCH_STOCK_NON_DEBITE_COUNT_SUCCESS =
	"FETCH_STOCK_NON_DEBITE_COUNT_SUCCESS"

export function fetchStockNonDebiteCount() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/inventaire/stock-non-debite`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) =>
				dispatch({
					type: FETCH_STOCK_NON_DEBITE_COUNT_SUCCESS,
					payload: json.count,
				}),
			)
			.catch(() => {})
	}
}
